export default __webpack_public_path__ + "d6.png";